import React from 'react';
import videojs from 'video.js'
import CSSModules from 'react-css-modules';
import styles from './styles.module.css';
import Loading from '../Loading/Loading';

class VideoPlayer extends React.Component {
    
  constructor() {
    super();
  
    this.state = {
      notLive: false,
      error: false,
    };

    this.errorTimeout = setTimeout(() => {
      this.setState({
        error: true,
      });
      this.initPlayer();
    }, 15000);

  }

  componentDidMount() {
    this.initPlayer();
  };

  initPlayer() {
    // if (process.env.REACT_APP_STREAM_KEY === "demo") return;

    if (this.player) {
      // if we have errored
      if (this.state.error) {
        // this.player.options(this.props);
        this.player.src(this.props.sources[0]);
        this.player.load();
        this.player.play();
        return;
      }
    } else {
      this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
        console.log('onPlayerReady', this);
      });
    }

    // let interval;

    this.player.on("error", () => {
      // alert("error");
      this.setState({
        error: true,
      });

      clearTimeout(this.errorTimeout);
      this.retryTimeout = setTimeout(() => {
        this.initPlayer();
      }, 10000);
    });

    this.player.on("loadeddata", () => {
      // alert("error");
      clearTimeout(this.errorTimeout);
      this.setState({
        error: false,
      })
    });
  }

  // destroy player on unmount
  componentWillUnmount() {
    clearTimeout(this.retryTimeout);
    if (this.player) {
      this.player.dispose()
    }
  }

  refresh() {
    document.location = document.location;
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    // if (this.state.notLive) {
    //   return (
    //     <div styleName="container"> 
    //     </div>
    //   )
    // }

    return (
      <div styleName="container"> 
        {/*this.state.loading && <Loading />*/}
        {(!this.state.loading && this.state.error) && (
          <div>
            <img styleName="brb" src="./images/brb.png"/>
          </div>
        )}
        <div styleName={(this.state.error) ? "hidden" : ''}>
          <div data-vjs-player>
            <video styleName="video" ref={ node => this.videoNode = node } className="video-js"></video>
          </div>
        </div>
      </div>
    )
  }
}

export default CSSModules(VideoPlayer, styles);